import React from "react";
import { cn } from "../../../common/u1/cn";
import { StatusBadge } from "../../../common/u1/StatusBadge";
import { ClockIcon } from "../../../../assets/ui/icons";

/* A tracked business's status. */
export const TrackedStatusBadge = ({ status = "listed", className = "" }) => {
  if (status === "in_progress") {
    return (
      <span
        className={cn(
          "inline-flex items-center gap-1.5 h-[26px] px-[11px] rounded-full border",
          "text-[12px] font-semibold tracking-[.01em] whitespace-nowrap font-sans",
          "bg-[var(--warning-soft)] text-[var(--gold-deep)] border-[var(--gold-border)]",
          className
        )}
      >
        <ClockIcon size={13} className="shrink-0" />
        In progress
      </span>
    );
  }

  return <StatusBadge status={status} className={className} />;
};

export default TrackedStatusBadge;
